export const INITTRANSLATIONS = '@@Translation/Init';
export const EDITITEM = '@@Translation/Edit';